// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"c786b1f6","409":"41ac6a47","453":"856c7687","470":"1dae6398","492":"14bbd086","511":"386e433f","540":"1bc46109","590":"3be3eca3","756":"f64cfc44","886":"cb46cc65","896":"24b918de","929":"c9807098","939":"eaab61d9"}[chunkId] + ".chunk.js";
};